const COLOR_SLOTS = ['primary', 'secondary', 'tertiary', 'quaternary', 'quinary']

function asColor(value) {
  if (!Array.isArray(value)) return null
  return value.length === 3 ? [...value, 1] : [...value]
}

function readControlEffects(data) {
  const control = (data?.layers || []).find((layer) => layer.nm === 'control')
  const effects = { stroke: 2 }
  for (const slot of COLOR_SLOTS) {
    effects[slot] = [1, 1, 1, 1]
  }

  for (const effect of control?.ef || []) {
    for (const item of effect.ef || []) {
      const value = item?.v?.k
      if (effect.nm === 'stroke' && item.nm === 'Menu' && typeof value === 'number') {
        effects.stroke = value
      }
      if (COLOR_SLOTS.includes(effect.nm) && item.nm === 'Color') {
        const color = asColor(value)
        if (color) effects[effect.nm] = color
      }
    }
  }

  return effects
}

function scaleStrokeValue(value, menu) {
  if (typeof value === 'number') return (value / 2) * menu
  if (Array.isArray(value) && value.every((entry) => typeof entry === 'number')) {
    return value.map((entry) => (entry / 2) * menu)
  }
  return value
}

function colorFromExpression(expression, effects) {
  for (const slot of COLOR_SLOTS) {
    if (expression.includes(`effect('${slot}')`) && expression.includes('Color')) {
      return effects[slot]
    }
  }
  return null
}

function visit(node, effects) {
  if (Array.isArray(node)) {
    node.forEach((child) => visit(child, effects))
    return
  }
  if (!node || typeof node !== 'object') return

  if (typeof node.x === 'string' && node.x.length > 2) {
    const color = colorFromExpression(node.x, effects)
    if (color) {
      node.k = [...color]
    } else if (node.x.includes("effect('stroke')") && node.x.includes('Menu')) {
      node.k = scaleStrokeValue(node.k, effects.stroke)
    }
    delete node.x
  }

  Object.values(node).forEach((child) => visit(child, effects))
}

export function remainingLottieExpressions(node, found = []) {
  if (Array.isArray(node)) {
    node.forEach((child) => remainingLottieExpressions(child, found))
    return found
  }
  if (!node || typeof node !== 'object') return found
  if (typeof node.x === 'string' && node.x.length > 2) found.push(node.x)
  Object.values(node).forEach((child) => remainingLottieExpressions(child, found))
  return found
}

export function resolveLottieControlExpressions(data) {
  if (!data || typeof data !== 'object') return data
  visit(data, readControlEffects(data))
  return data
}

export function cloneLottieData(data) {
  if (!data || typeof data !== 'object') return data
  return typeof structuredClone === 'function'
    ? structuredClone(data)
    : JSON.parse(JSON.stringify(data))
}
